module.exports = __webpack_public_path__ + "img/alabama-poultry-logo.4854143b.jpg";